/**
 * Format an ajv error into a human-readable message.
 */
function formatErrorMessage(error) {
    const { keyword, params, message } = error;
    switch (keyword) {
        case 'required':
            return `${params.missingProperty} is required`;
        case 'minLength':
            return `Must be at least ${params.limit} characters`;
        case 'maxLength':
            return `Must be at most ${params.limit} characters`;
        case 'minimum':
            return `Must be at least ${params.limit}`;
        case 'maximum':
            return `Must be at most ${params.limit}`;
        case 'pattern':
            return 'Invalid format';
        case 'format':
            return `Invalid ${params.format} format`;
        case 'type':
            return `Must be ${params.type}`;
        case 'enum':
            return `Must be one of: ${params.allowedValues.join(', ')}`;
        case 'const':
            return `Must be ${params.allowedValue}`;
        default:
            return message ?? 'Invalid value';
    }
}
/**
 * Convert ajv instancePath to form path notation.
 * E.g., "/foo/0/bar" becomes "foo[0].bar" (matching joinPath output).
 */
function instancePathToPath(instancePath) {
    if (!instancePath)
        return '';
    const segments = instancePath.slice(1).split('/');
    return segments.reduce((acc, seg) => {
        if (!acc)
            return seg;
        // Use bracket notation for numeric segments (array indices)
        if (/^\d+$/.test(seg))
            return `${acc}[${seg}]`;
        return `${acc}.${seg}`;
    }, '');
}
/**
 * Transform ajv errors to ValidationErrors format.
 */
export function transformAjvErrors(errors) {
    if (!errors)
        return {};
    const result = {};
    for (const error of errors) {
        let path = instancePathToPath(error.instancePath);
        // For 'required' errors, the missing property is in params, not instancePath
        if (error.keyword === 'required' && error.params.missingProperty) {
            path = path ? `${path}.${error.params.missingProperty}` : error.params.missingProperty;
        }
        // Only keep first error for each path
        if (!result[path]) {
            result[path] = formatErrorMessage(error);
        }
    }
    return result;
}
